module.exports = __webpack_public_path__ + "static/scale-model-of-nebraska-history-museum-in-lincoln-nebraska-2b60a90043ee08429135a6045e4c6545.png";